import {getBindingSource} from '@packages/systems/dynamo/utils/ParamPanelUtils';

import {getItemRefOptions} from './getItemRefOptions';
import {getOptionOptions} from './getOptionOptions';

import {__DEPRECATED__getInitialValues, getOperatorOptions} from './shared';

import {type CollectionStateType} from '@packages/systems/core/records/CollectionStateType';
import type {ParamPanelState} from './types';
import type {ConsolidatedBindingContext} from '@packages/systems/dynamo/gateway';
import type {Locale} from '@packages/systems/localization-types';

export function fieldChangeHandler({
  handleChange,
  bindingContext,
  parentBindingContext,
  operator: prevOperator,
  collectionState,
  currentLocale,
}: {
  handleChange: (arg1: Partial<ParamPanelState>) => void;
  bindingContext: ConsolidatedBindingContext | null;
  parentBindingContext: ConsolidatedBindingContext | null;
  operator: ParamPanelState['operator'];
  collectionState: CollectionStateType;
  currentLocale?: Locale | null | undefined;
}) {
  return function onFieldChange(fieldPath: string) {
    const bindingSource = bindingContext
      ? getBindingSource(fieldPath, bindingContext)
      : null;

    const fieldType = bindingSource ? bindingSource.type : '';
    const fieldInnerType =
      bindingSource && bindingSource.type === 'Set'
        ? bindingSource.meta.innerType
        : '';

    const availableOperators = getOperatorOptions(
      fieldPath,
      fieldType,
      fieldInnerType
    );

    const operator = availableOperators.some((o) => o.id === prevOperator)
      ? prevOperator
      : // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        availableOperators[0].id;

    const availableItemRefOptions = bindingSource
      ? getItemRefOptions({
          bindingSource,
          parentBindingContext,
          collectionState,
          currentLocale,
        })
      : [];

    const availableOptionOptions = bindingSource
      ? getOptionOptions(bindingSource)
      : [];

    handleChange({
      fieldPath,
      // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'OperatorId'.
      operator,
      ...__DEPRECATED__getInitialValues({
        fieldType,
        availableItemRefOptions,
        availableOptionOptions,
      }),
    });
  };
}
